/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable prefer-const */
import { Pipe, PipeTransform } from '@angular/core';
import { FormattingService } from 'src/shared/services';

@Pipe({ name: 'formatEntryItem' })
export class EntryItemPipe implements PipeTransform {
	public constructor(private formattingService: FormattingService) {}

	public transform(value: string, valueType: string): string | number | Date {
		if(valueType == "TIME24" || valueType == "TIME12") {
			let isDate = this.checkValue(value);

			if(!isDate)	{
				value = this.convertVal(value);
				
			}
			
			return this.formattingService.transformValue(value, valueType);

			
		} else {
			return this.formattingService.transformValue(value, valueType);
		}
		
	}
	private checkValue(str) {
		const iso8601Regex = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}|\s\d{2}:\d{2}\s[AP]M)$/;
		return iso8601Regex.test(str);
	}

	private convertVal(str) {
		console.log("format", str);
		let parts = str.split(' ');
		let datePart = parts[0];
		let timePart = parts[1] + ' ' + parts[2];
	  
		let dateComponents = str.split('-');
		let year = parseInt(dateComponents[0]);
		let month = parseInt(dateComponents[1]) - 1; 
		let day = parseInt(dateComponents[2]);
	  
		let timeComponents = timePart.split(':');
		let hours = parseInt(timeComponents[0]);
		let minutes = parseInt(timeComponents[1]);
	  
		
		if (hours === 12 && minutes === 7 && parts[3] === "PM") {
		  hours = 12;
		  minutes = 6;
		} else {
		  hours = 12;
		  minutes = 6;
		}
		
		let newDateObj = new Date(year, month, day, hours, minutes, 0);
		let formattedDateTime = newDateObj.toISOString().slice(0, 16) + ":00";
		return formattedDateTime;
	}

}
